import React from "react";
import { momentsCarouselImage } from "../config/images";

/**
 * PhotoCarousel
 * A Bootstrap carousel for showcasing a set of photos with captions.
 * Props:
 *  - images: [{ id, image, caption }] - `image` is a lookup key resolved
 *    via momentsCarouselImage() in src/config/images.js
 *  - carouselId: unique DOM id (required if more than one carousel appears
 *    on the same page)
 */
function PhotoCarousel({ images = [], carouselId = "apkPhotoCarousel" }) {
  if (!images.length) return null;

  return (
    <div className="photo-carousel-wrap">
      <div id={carouselId} className="carousel slide" data-bs-ride="carousel" data-bs-interval="4000">
        <div className="carousel-indicators">
          {images.map((img, idx) => (
            <button
              key={img.id}
              type="button"
              data-bs-target={`#${carouselId}`}
              data-bs-slide-to={idx}
              className={idx === 0 ? "active" : ""}
              aria-current={idx === 0 ? "true" : undefined}
              aria-label={`Photo ${idx + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner photo-carousel-inner">
          {images.map((img, idx) => (
            <div className={`carousel-item${idx === 0 ? " active" : ""}`} key={img.id}>
              <img src={momentsCarouselImage(img.image)} className="d-block w-100 photo-carousel-img" alt={img.caption} />
              {img.caption && (
                <div className="carousel-caption d-none d-md-block photo-carousel-caption">
                  <p className="mb-0 fw-semibold">{img.caption}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <button className="carousel-control-prev" type="button" data-bs-target={`#${carouselId}`} data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target={`#${carouselId}`} data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default PhotoCarousel;
